'use client';
import { useState, useEffect } from 'react';

import MyProfile from './MyProfile/MyProfile';
import MySolutions from './MySolutions/MySolutions';
import Settings from './Settings/Settings';
import ProfileSidebar from './ProfileSidebar';
import PhoneProfileMenu from './PhoneProfileMenu';
import { AppLayout } from '../Layout/AppLayout';
import { usePackStorage } from '../Layout/usePackStorage';
export default function ProfileFinal() {
  const { purchasedPacks, selectedPack, handlePackChange } = usePackStorage();
  const [currentScreen, setCurrentScreen] = useState('my-profile');
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(true);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const handleScreenChange = (screen) => {
    setCurrentScreen(screen);
    if (isMobileOrTablet) {
      setShowMobileMenu(false);
    }
  };

  const handleBack = () => {
    if (isMobileOrTablet && ['my-profile', 'my-solutions', 'quizr-settings'].includes(currentScreen)) {
      setShowMobileMenu(true);
    }
  };

  const renderCurrentScreen = () => {
    if (isMobileOrTablet && showMobileMenu) {
      return <PhoneProfileMenu onScreenChange={handleScreenChange} />;
    }

    switch (currentScreen) {
      case 'my-profile':
        return <MyProfile onBack={isMobileOrTablet ? handleBack : null} />;
      case 'my-solutions':
        return <MySolutions onBack={isMobileOrTablet ? handleBack : null} />;
      case 'quizr-settings':
        return <Settings onBack={isMobileOrTablet ? handleBack : null} />;
      default:
        return <MyProfile onBack={isMobileOrTablet ? handleBack : null} />;
    }
  };

  const shouldRenderProfileSidebar =
    !isMobileOrTablet && ['my-profile', 'my-solutions', 'quizr-settings'].includes(currentScreen);

  // ✅ Mobile view with sidebar at the bottom
  if (isMobileOrTablet) {
    return (
      <AppLayout>
        <div className="flex-1 min-w-0 pb-[80px]">
          {/* Adjust pb-[80px] as per Sidebar height */}
          {renderCurrentScreen()}
        </div>
      </AppLayout>
    );
  }

  // ✅ Desktop view remains unchanged
  return (
    <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack} onPackChange={handlePackChange}>
      <div className="flex-1 min-w-0 overflow-hidden flex justify-center">
        <div className="h-screen w-full max-w-6xl flex flex-col">
          <div className="flex flex-1 overflow-hidden">
            {shouldRenderProfileSidebar && (
              <div className="hidden lg:block w-64 flex-shrink-0 h-full overflow-hidden">
                <ProfileSidebar currentScreen={currentScreen} onScreenChange={handleScreenChange} />
              </div>
            )}

            <div className="flex-1 min-w-0 h-full overflow-y-auto">
              <div className="w-full px-8 py-6 md:py-8">
                <div className="w-full h-full">{renderCurrentScreen()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
